module.exports = __webpack_public_path__ + "img/golden-line.7661bb77.png";